import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-x-4" }
const _hoisted_2 = { class: "flex flex-row items-center text-center justify-center gap-x-2" }
const _hoisted_3 = {
  key: 0,
  class: "py-3 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-3 mt-2"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
    fill: "#F5A324"
  })
], -1)
const _hoisted_5 = { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-x-6 mt-6 relative" }
const _hoisted_7 = { class: `p-field-checkbox-grey mt-4 text-left` }
const _hoisted_8 = { class: `ml-2 text-px xxl:text-14px text-black-lp-100 font-normal` }
const _hoisted_9 = {
  key: 1,
  class: "grid grid-cols-2 gap-x-6 mt-6 relative"
}
const _hoisted_10 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_11 = {
  key: 3,
  class: "gap-x-6 mt-6"
}
const _hoisted_12 = { class: "grid grid-cols-2 gap-x-6 mt-6" }
const _hoisted_13 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_14 = { class: "flex flex-row ml-1" }
const _hoisted_15 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_16 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_17 = { class: "flex flex-row ml-1" }
const _hoisted_18 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_19 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-2 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
      fill: "#F5A324"
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }, [
    /*#__PURE__*/_createTextVNode(" Harap isi komoditas dengan benar sesuai "),
    /*#__PURE__*/_createVNode("a", {
      href: "https://lionparcel.com/sk",
      target: "blank",
      class: " underline"
    }, "syarat & ketentuan"),
    /*#__PURE__*/_createTextVNode(" yang berlaku. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InfoInsurance = _resolveComponent("InfoInsurance")!
  const _component_SectionGoodsCategory = _resolveComponent("SectionGoodsCategory")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryFeeTypes, (option) => {
        return (_openBlock(), _createBlock("div", {
          key: option.value,
          class: 
          `
          h-full
          rounded-xl
          py-1
          px-4
          font-montserrat
          cursor-pointer
          ${
            _ctx.isTabActive(option.value)
              ? 'border border-red-lp-300 bg-red-lp-50'
              : option.disabled
              ? 'bg-gray-lp-200 border border-gray-lp-1400 cursor-not-allowed'
              : 'bg-white border border-gray-lp-1400'
          }
          flex
          justify-center
        `
        ,
          onClick: ($event: any) => (option.disabled ? null : _ctx.onChangeDeliveryFeeType(option.value))
        }, [
          _createVNode("div", _hoisted_2, [
            (option.logo)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: 
              require(`@/app/ui/assets/svg/${option.logo}${
                option.disabled ? '-inactive' : ''
              }.svg`)
            ,
                  class: "max-w-none w-12 mr-2",
                  alt: "delivery-types"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createVNode("p", {
              class: 
              `
          text-14px
          text-center
    ${option.disabled ? 'text-gray-lp-600' : 'text-black'}
          xxl:text-16px font-medium`
            
            }, _toDisplayString(option.name), 3)
          ])
        ], 10, ["onClick"]))
      }), 128))
    ]),
    (_ctx.error.senderPhoneIsBlacklist || _ctx.shippingTypeFraudLimited)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("p", _hoisted_5, _toDisplayString(_ctx.error.senderPhoneIsBlacklist || _ctx.error.senderPhoneLimited), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('bookingShipment.column.itemPrice'),
        fontSize: 14
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lp_input, {
            modelValue: _ctx.modelValue.sttGoodsEstimatePrice,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.sttGoodsEstimatePrice = $event)),
            prefix: _ctx.prefixCurrency,
            format: _ctx.formatEstimationPrice,
            onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
            placeholder: _ctx.placeholderItemPrice,
            onChange: _cache[3] || (_cache[3] = (res)=>{
            _ctx.fullFilledCOD(res)
            _ctx.checkFocus()
          }),
            errorIcon: false,
            error: _ctx.errorEstimationPrice,
            errorCaption: 
            _ctx.errorEstimationPrice
              ? `${_ctx.errMsgPrice}`
              : _ctx.$t('bookingShipment.error.itemPrice')
          ,
            onFocus: _ctx.onSetFieldIndexEstPrice,
            disabled: "",
            disableBackground: ""
          }, null, 8, ["modelValue", "prefix", "format", "placeholder", "error", "errorCaption", "onFocus"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        fontSize: 14,
        label: _ctx.$t('bookingShipment.column.protection'),
        tooltipTitle: _ctx.$t('bookingShipment.tooltip.insurance'),
        tooltipDescription: _ctx.$t('bookingShipment.tooltip.insuranceMsg'),
        isDarkMode: ""
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Checkbox, {
              id: "insurance",
              modelValue: _ctx.isInsuranceBasic,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isInsuranceBasic = $event)),
              key: _ctx.isInsuranceBasic,
              onChange: _ctx.onChangeInsurance,
              binary: true,
              disabled: true
            }, null, 8, ["modelValue", "onChange"]),
            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("bookingShipment.column.shippingProtection")), 1)
          ])
        ]),
        _: 1
      }, 8, ["label", "tooltipTitle", "tooltipDescription"])
    ]),
    (_ctx.deliveryFeeType === 'cod' && _ctx.isCodAmount && _ctx.accountIsNonForeign)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.codFeeOptional'),
            optional: true,
            fontSize: 14
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.modelValue.sttCodAmount,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.sttCodAmount = $event)),
                prefix: _ctx.prefixCurrency,
                format: _ctx.formatEstimationPrice,
                onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                placeholder: _ctx.$t('bookingShipment.placeholder.codFee'),
                onFocus: _ctx.onSetFieldIndexEstPrice,
                disabled: true,
                disableBackground: true
              }, null, 8, ["modelValue", "prefix", "format", "placeholder", "onFocus"])
            ]),
            _: 1
          }, 8, ["label"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.accountIsNonForeign && _ctx.accountData.isPosAccount && (_ctx.bookingRetail || _ctx.isCA))
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          (_ctx.isShowBanner)
            ? (_openBlock(), _createBlock(_component_InfoInsurance, {
                key: 0,
                modelValue: _ctx.formData,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData = $event)),
                bannerType: _ctx.insuranceCondition,
                commission: _ctx.insuranceDetail?.commissionPos,
                profit: _ctx.insuranceProfit,
                maxProtection: _ctx.insuranceDetail?.maxProtection,
                cost: _ctx.insuranceDetail?.cost,
                estimationPrice: _ctx.modelValue.sttGoodsEstimatePrice
              }, null, 8, ["modelValue", "bannerType", "commission", "profit", "maxProtection", "cost", "estimationPrice"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showGoodsCategory)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode(_component_SectionGoodsCategory, { goodsNames: _ctx.goodsNames }, null, 8, ["goodsNames"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('bookingShipment.column.commodity'),
        fontSize: 14
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectSearch, {
            class: "mt-1.5",
            options: _ctx.commodities,
            isLoading: _ctx.isLoadingCommodity,
            onFilter: _ctx.fetchCommodityList,
            keyName: "name",
            keyValue: "code",
            placeholder: _ctx.$t('bookingShipment.placeholder.commodity'),
            modelValue: _ctx.modelValue.sttCommodityName,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.modelValue.sttCommodityName = $event)),
            isShowErrorMessage: false,
            isShowErrorIndicator: 
            (_ctx.modelValue.sttCommodityName?.status === 'inactive' &&
              _ctx.modelValue.sttCommodityName) ||
              _ctx.errorEmbargo.comodity ||
              _ctx.errorCommodity
          ,
            errorCaption: 
            _ctx.modelValue.sttCommodityName?.status === 'inactive' &&
            _ctx.modelValue.sttCommodityName
              ? this.$t('bookingShipment.error.inactiveCommodity')
              : _ctx.errorCommodity
              ? _ctx.$t('bookingShipment.error.mandatoryCommodity')
              : ''
          ,
            onChange: _ctx.changeCommodities,
            onFocus: _ctx.onFocusCommodityList,
            "is-disabled": _ctx.isDisabledCommodity,
            disabledBackground: _ctx.isDisabledCommodity,
            maxHeight: "270px",
            useInfiniteScroll: "",
            onScrolled: _ctx.fetchCommodityListInfiniteScroll,
            idInput: "commodity-booking",
            autoUpDown: ""
          }, {
            "custom-option": _withCtx(({item}) => [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", null, _toDisplayString(item.name), 1),
                _createVNode("div", _hoisted_14, [
                  (item.isQuarantine)
                    ? (_openBlock(), _createBlock("span", _hoisted_15, " K "))
                    : _createCommentVNode("", true),
                  (item.isDangerousGoods)
                    ? (_openBlock(), _createBlock("span", _hoisted_16, " DG "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            "selected-info": _withCtx(({selected}) => [
              _createVNode("div", _hoisted_17, [
                (selected && selected.isQuarantine)
                  ? (_openBlock(), _createBlock("span", _hoisted_18, " K "))
                  : _createCommentVNode("", true),
                (selected && selected.isDangerousGoods)
                  ? (_openBlock(), _createBlock("span", _hoisted_19, " DG "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["options", "isLoading", "onFilter", "placeholder", "modelValue", "isShowErrorIndicator", "errorCaption", "onChange", "onFocus", "is-disabled", "disabledBackground", "onScrolled"]),
          _hoisted_20
        ]),
        _: 1
      }, 8, ["label"]),
      _renderSlot(_ctx.$slots, "woodpacking")
    ])
  ]))
}